// Stack — flex row/column with token-based gap. Thin layout primitive that
// removes one-off flexbox CSS from screens. Gap accepts a spacing-scale step.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './stack.css';

export function Stack({
  as: Tag = 'div',
  direction = 'column',
  gap = 4,
  align,
  justify,
  wrap = false,
  className,
  style,
  children,
  ...rest
}) {
  return (
    <Tag
      className={cx('stack', `stack--${direction}`, wrap && 'stack--wrap', className)}
      style={{
        '--stack-gap': `var(--s-${gap})`,
        alignItems: align,
        justifyContent: justify,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

Stack.propTypes = {
  as: PropTypes.elementType,
  direction: PropTypes.oneOf(['row', 'column']),
  /** Spacing-scale step (1–16) → var(--s-N). */
  gap: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 8, 10, 12, 16]),
  align: PropTypes.string,
  justify: PropTypes.string,
  wrap: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default Stack;
